import styled from '@xstyled/styled-components'

export const StyledSharePanelContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: 24
})

export const StyledSharePanelFooter = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end'
})
